<section class="section-inset-b event-form">
  <header class="palette-dark section-inset-y section-outset-b event-form__header">
    <div class="container">
      <app-breadcrumbs class="d-block mb-3" [breadcrumbs]="(breadcrumbs$ | async) ?? []"></app-breadcrumbs>

      <h2 class="text-tertiary event-form__header__title">
        <span *ngIf="(isNew$ | async) === false">{{ 'event-formulier-bewerken-titel' | fromDictionary }}</span>
        <span *ngIf="isNew$ | async">{{ 'event-formulier-aanmelden-titel' | fromDictionary }}</span>
      </h2>
    </div>
    <app-bg-wave class="event-form__wave" [autoPlay]="false" [strokeColor]="'transparent'" [bgColor]="'var(--bs-light)'"></app-bg-wave>
  </header>

  <div class="container text-max-width">
    <app-alert [message]="'event-formulier-geen-rechten-tekst' | fromDictionary" [status]="'info'" *ngIf="!editMode">
      <a [routerLink]="(event$ | async)?.url" class="mt-4 button button--light">Terug naar activiteit</a>
    </app-alert>
  </div>
  <div class="container" *ngIf="formFields$ | async as formFields">
    <app-form-stepper
      [hasEdit]="!!(event$ | async)"
      [appearance]="'fill'"
      [config]="formFields"
      [fieldsets]="fieldsets ?? []"
      (formSubmit)="handleSubmit($event)"
      [submitButtonLabel]="prefix + '-verzenden-knop-tekst' | fromDictionary"
      [submitDisabled]="(formLoading$ | async) ?? false"
      [stepsTitle]="prefix + '-stappen-titel' | fromDictionary"
      [validateStepsOnInit]="!!(event$ | async)"
      (stepChange)="handleStepChange($event)"
    >
      <app-alert
        slot="form-alert"
        *ngIf="formError$ | async as error"
        [status]="'danger'"
        [message]="error"
        class="d-block mb-3"
      ></app-alert>

      <div class="my-4" slot="form-stepper-bottom">
        <app-actions-card
          class="mb-3 d-block form-actions-card"
          [image]="{ url: 'ambassadeur-afbeelding-url' | fromDictionary }"
          [altText]="'ambassadeur-afbeelding-alt-tekst' | fromDictionary"
          [text]="'ambassadeur-cta-tekst' | fromDictionary"
          [title]="'ambassadeur-cta-titel' | fromDictionary"
          [link]="'ambassadeur-cta-link' | fromDictionary"
        ></app-actions-card>
        <button class="button button-outline button--danger" *ngIf="event$ | async as event" (click)="deleteEvent(event)">
          <app-icon anchor="icon-trash"></app-icon>
          <span>{{ 'evenement-verwijderen-button-label' | fromDictionary }}</span>
        </button>
      </div>
    </app-form-stepper>
  </div>
</section>
